import { useRef } from 'react';
import { useInView } from 'framer-motion';

// Dispara uma vez quando o elemento entra na tela: gráficos "crescem" na hora em que o
// usuário chega neles, e não enquanto ainda estão lá embaixo fora da vista.
export function useRevealOnce<T extends Element = HTMLDivElement>() {
  const ref = useRef<T>(null);
  const inView = useInView(ref, { once: true, margin: '0px 0px -60px 0px' });
  return [ref, inView] as const;
}
